import {
  TASK_STATUS_LABELS,
  TASK_TYPE_LABELS,
  taskStatusColor,
} from "./skillFichaHelpers";

const SIN_TEMPORADA = "Sin temporada";
const SIN_CLIENTE = "Sin cliente";

export function taskClientLabel(row) {
  return (
    row?.CustomerName ||
    (row?.CustomerId ? `Cliente #${row.CustomerId}` : null) ||
    row?.SkillSlug ||
    SIN_CLIENTE
  );
}

export function taskSeasonLabel(row) {
  const t = String(row?.Temporada || "").trim();
  return t || SIN_TEMPORADA;
}

/**
 * groupBy: "season" → Temporada → Cliente → tareas
 * groupBy: "client" → Cliente → Temporada → tareas
 */
export function buildAgentTasksTree(rows = [], groupBy = "season") {
  const filtered = Array.isArray(rows) ? rows : [];
  const rootMap = new Map();

  for (const row of filtered) {
    const season = taskSeasonLabel(row);
    const client = taskClientLabel(row);
    const L1 = groupBy === "client" ? client : season;
    const L2 = groupBy === "client" ? season : client;

    if (!rootMap.has(L1)) {
      rootMap.set(L1, {
        id: `l1:${L1}`,
        label: L1,
        kind: groupBy === "client" ? "client" : "season",
        children: new Map(),
        tasks: [],
      });
    }
    const n1 = rootMap.get(L1);
    if (!n1.children.has(L2)) {
      n1.children.set(L2, {
        id: `l2:${L1}::${L2}`,
        label: L2,
        kind: groupBy === "client" ? "season" : "client",
        tasks: [],
      });
    }
    n1.children.get(L2).tasks.push(row);
  }

  const sortLabel = (a, b) =>
    String(a).localeCompare(String(b), "es", {
      numeric: true,
      sensitivity: "base",
    });

  const roots = [...rootMap.values()]
    .map((n1) => {
      const children = [...n1.children.values()]
        .map((n2) => ({
          ...n2,
          tasks: [...n2.tasks].sort((a, b) =>
            String(b.updatedAt || "").localeCompare(String(a.updatedAt || "")),
          ),
          count: n2.tasks.length,
        }))
        .sort((a, b) => sortLabel(a.label, b.label));
      const count = children.reduce((s, c) => s + c.count, 0);
      return { ...n1, children, count };
    })
    .sort((a, b) => {
      if (a.label === SIN_TEMPORADA || a.label === SIN_CLIENTE) return 1;
      if (b.label === SIN_TEMPORADA || b.label === SIN_CLIENTE) return -1;
      return sortLabel(a.label, b.label);
    });

  return roots;
}

export { TASK_STATUS_LABELS, TASK_TYPE_LABELS, taskStatusColor };
